require("style-loader!css-loader!sass-loader!./font-awesome-styles.loader!./font-awesome.config.js");



//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-loader/index.js
// module id = 1089
// module chunks = 1